import { ICalendarizacion, IReqBodyValidarPonderacion, IResValidarPonderacion, IDetallePonderacion, IRegistroCalificacion, IResValidarNotas } from './../../interfaces/ponderaciones';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICargaArchivo, IListaAnhos, IListaAsignaturas, IListaPeriodos, IListaArchivos, IListaSecciones, IParamsFiltrosQuery, IResPonderaciones, IReqBodyCrearPonderacion, IResCrearPonderacion, IPonderacion } from 'src/app/interfaces/ponderaciones';
import { environment } from 'src/environments/environment';
import { PerfilamientoService } from '../perfilamiento/perfilamiento.service';

@Injectable({
  providedIn: 'root'
})
export class PonderacionesService {

  constructor(
    private http: HttpClient,
    private _perfilamiento: PerfilamientoService
  ) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getListaArchivosPonderacionMasiva(): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/obtenerListaArchivosPonderacion`
    return this.http.get<any>(url, { headers: this.getHeaders() })
  }

  cargarArchivoPonderacionMasiva(dataArchivo: ICargaArchivo): Observable<IListaArchivos> {
    const url = `${environment.endpointAdministrativo}/v1/cargarArchivo`
    return this.http.post<IListaArchivos>(url, dataArchivo, { headers: this.getHeaders() })
  }

  descargarLogPonderacionMasiva(ponderacionId: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/obtenerArchivoLog/${ponderacionId}`;
    return this.http.get<any>(url, { headers: this.getHeaders() });
  }

  copiarPonderacionMasiva(body: any): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/copiarPonderacion`;
    return this.http.post<any>(url, body, { headers: this.getHeaders() });
  }

  descargarPonderacion(body: any): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/descargarArchivo`;
    return this.http.post<any>(url, body, { headers: this.getHeaders() });
  }

  // Ponderacion individual
  getFiltrosAnhos(): Observable<IListaAnhos> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-anyos`
    return this.http.get<IListaAnhos>(url, { headers: this.getHeaders() })
  }

  getFiltrosPeriodos(anho: number): Observable<IListaPeriodos> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-periodos?anyo=${anho}`
    return this.http.get<IListaPeriodos>(url, { headers: this.getHeaders() })
  }

  getFiltrosSedes(userId: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-sedes?usuario-id=${userId}`
    return this.http.get<any>(url, { headers: this.getHeaders() })
  }
  getFiltrosSedesSigla(userId: number, anyo: number, periodoId: number, asignaturaId: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-sedes-sigla?usuario-id=${userId}&anyo=${anyo}&periodo-id=${periodoId}&asignatura-id=${asignaturaId}`
    return this.http.get<any>(url, { headers: this.getHeaders() })
  }

  getFiltrosSecciones(filter: IParamsFiltrosQuery): Observable<IListaSecciones> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/buscar-secciones?anyo=${filter.anyo}&periodo-id=${filter.periodoId}&sede-id=${filter.sedeId}&asignatura-id=${filter.asignaturaId}`
    return this.http.get<IListaSecciones>(url, { headers: this.getHeaders() })
  }

  getFiltrosAsignaturas(filter: IParamsFiltrosQuery): Observable<IListaAsignaturas> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/buscar-asignatura?anyo=${filter.anyo}&periodo-id=${filter.periodoId}`
    return this.http.get<IListaAsignaturas>(url, { headers: this.getHeaders() })
  }

  getConfiguracionBase(anho: number, idPeriodo: number, idAsignatura: number): Observable<IResPonderaciones> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/configuracion-base?anyo=${anho}&periodo-id=${idPeriodo}&asignatura-id=${idAsignatura}`
    return this.http.get<IResPonderaciones>(url, { headers: this.getHeaders() })
  }

  listaPonderacionIndividual(body: any): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtenerLista`;
    return this.http.post<any>(url, body, { headers: this.getHeaders() });
  }

  crearPonderacionIndividual(body: IReqBodyCrearPonderacion): Observable<IResCrearPonderacion> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/crearPonderacion`;
    return this.http.post<IResCrearPonderacion>(url, body, { headers: this.getHeaders() });
  }

  getCalendarizacion(anho: number, idPeriodo: number, codigoProceso: string): Observable<ICalendarizacion> {
    const url = `${environment.endpointAdministrativo}/v1/calendarizacion/obtenerCalendarizacion?anyo=${anho}&periodo-id=${idPeriodo}&codigo-proceso=${codigoProceso}`;
    return this.http.get<ICalendarizacion>(url);
  }
  eliminarPonderacionIndividual(idPonderacion: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/eliminarPonderacion/${idPonderacion}`
    return this.http.delete<any>(url, { headers: this.getHeaders() })
  }

  obtenerCalendarizacion(body: any): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/calendarizacion/obtenerCalendarizacion`;
    return this.http.post<any>(url, body, { headers: this.getHeaders() });
  }
  obtenerPonderacionIndividual(idPonderacion: number): Observable<IPonderacion> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtenerDetallePonderacion/${idPonderacion}`
    return this.http.get<IPonderacion>(url)

  }
  modificarPonderacionIndividual(body: IPonderacion): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/modificarPonderacion`;
    return this.http.put<any>(url, body, { headers: this.getHeaders() });
  }

  validarPonderacionIndividual(body: IReqBodyValidarPonderacion): Observable<IResValidarPonderacion> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/validarPonderacion`;
    return this.http.post<IResValidarPonderacion>(url, body, { headers: this.getHeaders() });
  }

  detalleNotaPonderacion(ponderacionBaseId: number, tipoNota: string, seccion: string): Observable<IDetallePonderacion> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtenerNotasDetallePonderacion/${ponderacionBaseId}/${tipoNota}/${seccion}`
    return this.http.get<IDetallePonderacion>(url)
  }

  obtenerRegistroCalificaciones(body:any):Observable<any>{
    const url = `${environment.endpointDocente}/v1/ponderacion/individual/obtenerDetallePonderacionDocente`;
    return this.http.post<any>(url, body, { headers: this.getHeaders() });
  }

  modificarRegistroCalificaciones(body:IRegistroCalificacion):Observable<any>{
    const url = `${environment.endpointDocente}/v1/ponderacion/individual/modificarPonderacionDocente`;
    return this.http.put<any>(url, body, { headers: this.getHeaders() });
  }

  validarNotas(anyo: number, periodoId: number, sedeId: number, seccionId: number):Observable<IResValidarNotas>{
    const cstmUrl: string = this._perfilamiento.getUsuario().tipoUsuario === 'Backoffice' ? environment.endpointAdministrativo : environment.endpointDocente
    const url = `${cstmUrl}/v1/ponderacion/individual/validar-notas?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}&seccion-id=${seccionId}`;
    return this.http.get<IResValidarNotas>(url, { headers: this.getHeaders() });
  }
}
